import {
  AfterViewChecked,
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit, Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {
  SohoBusyIndicatorDirective,
  SohoListViewComponent
} from 'ids-enterprise-ng';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import * as urltemplate from 'url-template';

import {
  LMListContentFilterListUtilService,
  LMListEventService,
  LMListGridPagingService,
  LMListSpecUtilService,
  LMListUtilService
} from './services';
import {
  LMBusyIndicatorService,
  LMContextService,
  LMErrorUtilService,
  LMFormatUtilService,
  LMLoggerService,
  LMUrlUtilService
} from '@services/index';
import { LMListContentBaseComponent } from './lm-list-content-base.component';
import { LMListDragDropEvent } from './lm-list.component';
import { LMCommonUtilService } from '@utils/lm-common-util.service';
import { LMThemeService } from '@banner/lm-theme.service';
import { AppConstants } from '@utils/app.constants';
import { BreakpointChangeService } from '@drawer/breakpoint-change.service';

@Component({
  selector: 'lm-list-view',
  templateUrl: 'lm-list-view.component.html',
  styleUrls: [ './lm-list-view.component.scss' ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMListViewComponent extends LMListContentBaseComponent implements LMListContentInterface, OnDestroy, OnInit, AfterViewInit, AfterViewChecked {
  @HostBinding('attr.id') get attrId() {
    return this.elementId;
  }
  // @HostBinding('attr.data-automation-id') public listViewAutomationId: string;
  @HostBinding('style.height') get hostHeight() {
    if (this.implementsCartView) {
    //  this.elementRef.nativeElement.
      return (window.innerHeight - this.elementRef.nativeElement.getBoundingClientRect().top - 20) + 'px';
    }
  }

  @HostBinding('class.is-single-select') get isSingleSelectClass() {
    return this.selectionMode === 'single';
  }

  @HostBinding('class.has-button-row') get hasButtonRowClass() {
    return this.listSpec.busListSpec.displayFields[0]?.buttonRow;
  }

  @HostBinding('class.no-button-row') get noButtonRowClass() {
    return !this.listSpec.busListSpec.displayFields[0]?.buttonRow;
  }

  /**
   * View child reference to the soho busy indicator - use for paging.
   */
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) sohoBusyIndicator: SohoBusyIndicatorDirective;

  /**
   * The viewChild reference to the soho-listview.
   */
  @ViewChild('SohoListView') sohoListView: SohoListViewComponent;
  @ViewChild('modalPlaceholder', { read: ViewContainerRef, static: true }) modalPlaceholder: ViewContainerRef;

  @Input() set sortOrder(sortOrder: LMListSortOrder) {
    this.sortPage(sortOrder);
  }

  @Input() implementsDragAndDrop = false;

  /**
   * Only load data if filterCriteria or filterListFilterCriteria are set.
   */
  @Input() set hasFilterList(hasFilterList: boolean) {
    this.m_hasFilterList = hasFilterList;
  }

  get hasFilterList(): boolean {
    return this.m_hasFilterList;
  }

  @Output() toolbarButtonEvent = new EventEmitter<LMToolbarButtonEvent>();

  public hasNextPage = false;
  public hasPreviousPage = false;
  public hasFirstPage = false;
  public hasLastPage = false;
  public pageSize = 10;
  public pagerIdAttributes: SohoAttributesArray;
  public firstPageButtonTooltip;
  public previousPageButtonTooltip;
  public nextPageButtonTooltip;
  public lastPageButtonTooltip;
  public showPageSizeSelector = false;
  public selectionInProgress = false;
  public testVersion1: boolean;
  public uiLoadingIndicatorTimeout = 0;

  public listViewAutomationId: string;
  public sohoListViewAutomationId: string;

  public elementId: string;
  public recordCount = 0;
  public dataViewSet: LMDataViewSet;

  public dragDropSubscription: Subscription;
  public isFilterList: boolean;
  public selectionMode: SohoListViewSelectable;
  public showAsCard: boolean;
  public showAsMingleWidget: boolean;
  public initialBuildComplete = false;
  public hidePagerBar = false;
  public showEmptyMessage: boolean;
  public onMobile = false;
  public showCollapseButton$: Observable<boolean>;

  private allowMultiSelections = false;
  private m_hasFilterList = false;
  private resetSelectionFlag = false;
  private implementsCancelablePaging = false;
  private cancelPagingNotifier$: Subject<boolean>;
  private fFromDataViewChanged = false;
  private fFilterListCriteriaChanged = false;
  public implementsCartView = false;

  constructor(
    protected lmContextService: LMContextService,
    protected lmLoggerService: LMLoggerService,
    protected lmThemeService: LMThemeService,
    protected lmFormatUtilService: LMFormatUtilService,
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmCommonUtilService: LMCommonUtilService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmListContentFilterListUtilService: LMListContentFilterListUtilService,
    private lmListEventService: LMListEventService,
    private lmListGridPagingService: LMListGridPagingService,
    private lmListSpecUtilService: LMListSpecUtilService,
    private lmListUtilService: LMListUtilService,
    private lmUrlUtilService: LMUrlUtilService,
    private breakpointChangeService: BreakpointChangeService
  ) {
    super(lmLoggerService, lmThemeService, lmFormatUtilService);
    this.implementsCancelablePaging = this.lmContextService.isUiPagingRequestWaitTimeEnabled;
    this.onMobile = this.lmContextService.isMobileDevice();
    this.testVersion1 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1;
    this.uiLoadingIndicatorTimeout = this.lmContextService.uiLoadingIndicatorTimeout;

  }

  ngOnInit() {
    this.lmLoggerService.time({ id: '>> Total ListView ' + this.instanceId });
    this.clearEmptyMessage();
    this.validateInitialInputs();
    this.initialize();

    // -------------------------------------------------------------------------
    // If not dependentList then it can be build here. If it is a dependent
    // list then wait until fromDataViewChanged() function messaged.
    // -------------------------------------------------------------------------
    if (!this.listSpec.dependentList) {
      this.build();
    }
  }

  ngAfterViewInit() {
    if (this.hasFilterList && this.implementsDragAndDrop) {
      this.dragDropSubscription = this.lmListContentFilterListUtilService.cardDropEmitted$.subscribe(dropInfo => {
        this.lmListEventService.listDragDropEvent(new LMListDragDropEvent(this, dropInfo.row, dropInfo.filterRow));
      });
    }

    this.implementsCartView = this.elementRef.nativeElement.closest('.implements-cart-view');
  }

  ngAfterViewChecked(): void {
    if (this.componentDestroyed) {
      return;
    }

    if (this.listSpec.dependentList && (this.fFromDataViewChanged || this.fFilterListCriteriaChanged)) {
      this.fFromDataViewChanged = false;
      this.fFilterListCriteriaChanged = false;
      setTimeout(() => this.build());
    }

    if (!this.resetSelectionFlag) {
      return;
    }

    this.resetSelectionFlag = false;
    setTimeout(() => {
      let selectedRow = -1;
      const activatedRow = this.listState ? this.listState.activatedRow : -1;

      if (this.selectionMode !== 'mixed') {
        if (this.listState
          &&  this.listState.selectedRows
          &&  this.listState.selectedRows.length > 0) {
          selectedRow = this.listState.selectedRows[0];
        }
      }

      this.resetSelection(selectedRow, activatedRow);
    });
  }

  ngOnDestroy() {
    this.setComponentDestroyed();
    this.cancelOutstandingPagingRequest();

    if (this.dragDropSubscription && !this.dragDropSubscription.closed) {
      this.lmLoggerService.log([ this, this.instanceId, 'ngOnDestroy(): dragDropSubscription is still open, unsubscribing...' ]);
      this.dragDropSubscription.unsubscribe();
    }
  }

  protected loadManualData(): void {
    if (this.listSpec.dependentList && !this.componentDestroyed) {
      this.build();
    }
  }

  protected onFormButtonClicked(columnDef: ListGridColumn, dataView: LMDataView, row: any, cell: any, navigationParams: any, event: any): void {
    // Handle click of the no data message button
    if (columnDef.displayField.linkNavigation ||
      columnDef.displayField.navigation ||
      columnDef.displayField.httpUrl ||
      navigationParams
    ) {
      const uiLinkEvent: LMUILinkEvent = { columnDef, dataView, event, navigationParams, options: { fromNoDataMessageFormButton: true } };
      this.lmListEventService.uiLinkEvent(uiLinkEvent);
    } else if (columnDef.displayField.type === AppConstants.FORMBUTTON ||
      columnDef.displayField.type === AppConstants.SUBFORM ||
      columnDef.displayField.type === AppConstants.FORMREFERENCE ||
      columnDef.displayField.type === AppConstants.LISTREFERENCE) {
      this.lmListEventService.formButtonEvent(<LMFormButtonEvent>{ columnDef, dataView, row, cell, event });
    }
  }

  protected fromDataViewChanged() {
    if (this.listSpec.dependentList && !this.componentDestroyed) {
      this.fFromDataViewChanged = true;
    }
  }

  protected inSelectedListEditModeChanged(): void {
    if (!this.sohoListView) {
      return;
    }

    let row: number;
    const fromSelectionMode = this.selectionMode;
    const toSelectionMode = this.lmListSpecUtilService.getSelectionMode(this.listSpec, this.inSelectListEditMode, this.allowMultiSelections) as SohoListViewSelectable;;
    if (toSelectionMode !== fromSelectionMode) {
      const showSelectionCheckBox = toSelectionMode === 'mixed';
      const selectedRows = this.getSelectedRows();
      const selectedRow = selectedRows?.length > 0 ? selectedRows[ 0 ] : -1;
      row = (showSelectionCheckBox) ? selectedRow : this.activatedRow();
      this.unSelectAllRows();

      this.selectionMode = toSelectionMode;
      if (showSelectionCheckBox) {
        // Going from single select to multiple select
        this.sohoListView.disableItemDeactivation = true;
        this.listState.activatedRow = row;
      } else {
        // Going from multiple select to single select
        this.sohoListView.disableItemDeactivation = false;
        this.listState.selectedRows = [ row ];
      }

      // Calling change detection so the changes to the listview
      // are displayed before attempting to set focus within.
      this.resetSelectionFlag = true;
      this.sohoListView.updateRequired = true;
      this.changeDetectorRef.markForCheck();
    } else {
      if (this.dataViewSet.data.length === 0) {
        return;
      }

      if (!this.allowMultiSelections) {
        // Going from single select to single select
        if (this.getSelectedRow() === -1) {
          this.setSelectedRows([ 0 ] );
        }
        setTimeout(() => this.elementRef.nativeElement.getElementsByClassName('is-selected')[0].focus());
      } else {
        // Going from multiple select to multiple select
        if (this.activatedRow() === -1) {
          this.activateRow(0);
        }
        setTimeout(() => this.elementRef.nativeElement.getElementsByClassName('is-activated')[0].focus());
      }
    }
  }

  public setSelectListFocus() {
    if (!this.lmContextService.useSingleSelectList() || !this.lmListSpecUtilService.isSelectList(this.listSpec)) {
      return;
    }

    if (this.selectionMode === 'mixed' && this.activatedRow() !== -1) {
      const activatedRow = this.activatedRow();
      this.elementRef.nativeElement.getElementsByClassName('is-activated')[0].focus();
      this.sohoListView.activateItem(activatedRow);
    } else if (this.selectionMode === 'single' && this.getSelectedRow() !== -1) {
      const selectedRow = this.getSelectedRow();
      this.elementRef.nativeElement.getElementsByClassName('is-selected')[0].focus();
      this.sohoListView.select(selectedRow);
    }
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent) {
    this.lmListEventService.toolbarButtonEvent(toolbarButtonEvent);
  }

  public onUILinkEvent(uiLinkEvent: LMUILinkEvent) {
    this.lmListEventService.uiLinkEvent(uiLinkEvent);
  }

  public build() {
    this.lmLoggerService.log([ this, this.instanceId, 'build()' ]);
    this.initialPage();
    this.initialBuildComplete = true;
  }

  protected filterCriteriaChanged() {
    if (this.filterCriteria && this.initialBuildComplete) {
      this.filterPage();
    } else if (this.initialBuildComplete && this.filterCriteria === null) {
      // a search filter has been cleared
      this.initialPage(true);
    }
  }

  protected filterListCriteriaChanged() {
    if (this.hasFilterList && this.initialBuildComplete) {
      this.fFilterListCriteriaChanged = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  public initialize() {
    this.listViewAutomationId = 'lm-' + this.listSpec?.busListSpec?.automationId + '-listview';
    // this.sohoListViewAutomationId = 'lm-' + this.listSpec?.busListSpec?.automationId + '-soholistview';

    this.pagerIdAttributes = [
      { name: 'id', value: this.listSpec.busListSpec.id + '_pager' },
      { name: 'data-automation-id', value: 'lm-' + this.listSpec.busListSpec.automationId + '-pager' }
    ];

    this.hidePagerBar = this._hidePagerBar();
    this.pageSizes = this.lmListUtilService.getPageSizesArray(this.listSpec);
    this.pageSize = this.lmListUtilService.getPageSize(this.listSpec, this.listPersonalization); // || 10;
    // this.showPageSizeSelector = this.lmListUtilService.showPageSizeChooser(this.listSpec);

    if (this.lmContextService.testVersion() >= AppConstants.TESTVERSION_V3) {
      // ----------------------------------------------------------------------------
      // should have used busListSpec.id all along, but for backward compatability
      // have to keep busListSpec.name for backward compatability
      // ----------------------------------------------------------------------------
      this.elementId = this.listSpec.busListSpec.id + '_listview';
    } else {
      this.elementId = this.listSpec.busListSpec.name + '_listview';
    }

    this.allowMultiSelections = this.selectRequestData?.allowMultiSelections || false;
    this.selectionMode = this.lmListSpecUtilService.getSelectionMode(this.listSpec, this.inSelectListEditMode, this.allowMultiSelections) as SohoListViewSelectable;
    this.isFilterList = this.lmListSpecUtilService.isFilterList(this.listSpec);
    this.showAsMingleWidget = this.listSpec.showAsMingleWidget;

    const isCardViewWithDetailSections = this.lmListSpecUtilService.isCardViewWithDetailSections(this.listSpec);
    if (!this.showAsMingleWidget && !this.isFilterList
      &&   this.lmListSpecUtilService.isCardViewOnly(this.listSpec)
      &&  !isCardViewWithDetailSections
      &&  !this.lmListSpecUtilService.isDashBoardContent(this.listSpec)) {
      this.showAsCard = true;
    } else {
      this.showAsCard = false;
    }

    this.showCollapseButton$ = this.breakpointChangeService.isPhoneView$.pipe(
      map((isPhoneView: boolean) => isPhoneView ? false : isCardViewWithDetailSections)
    );
  }

  public getSelectedRows(): Array<number> {
    if (this.sohoListView) {
      const selectedItems = <Array<number>>this.sohoListView.getSelectedItems;
      if (selectedItems.length !== 0) {
        return selectedItems;
      }
    }

    return [];
  }

  public setSelectedRows(rows: Array<number>, scrollIntoView = true): void {
    if (!this.sohoListView) {
      return; // safety
    }

    if (rows[0] === -1) {
      return;
    }

    if (this.listSpec.busListSpec.selection === 'disabled') {
      return; // safety
    }

    // ---------------------------------------------------------------------
    // find the diff and only select rows not already selected. Otherwise
    // this.sohoListView.select seems to toggle current selected rows off
    // when called a 2nd time.
    // ---------------------------------------------------------------------
    const currentSelectedRows: number[] = this.getSelectedRows();
    const newlySelectedRows: number[] = rows.filter(row => !currentSelectedRows.includes(row));

    // adding a safety check if trying to delete the last row to make sure the newlySelectedRows index
    // is not out of bounds
    const dataGridSet = this.getDataViewSet();
    if (newlySelectedRows[0] >= dataGridSet?.data?.length) {
      newlySelectedRows[0] =  dataGridSet?.data?.length - 1;
    }
    this.sohoListView.select(newlySelectedRows);

    if (scrollIntoView) {
      // todo: ppatton put into runOutsideAngular?
      // Focus on 1st selected row
      const selectedElements = this.elementRef.nativeElement.getElementsByClassName('is-selected');
      if (this.sohoListView && selectedElements.length) {
        const selectedElement = selectedElements[0];
        this.lmCommonUtilService.scrollIntoView(selectedElement);
      }
    }
  }

  getSelectedRow(): number {
    if (this.sohoListView) {
      const selectedRows: SohoListViewItemReference[] = this.sohoListView.getSelectedItems;
      if (selectedRows && selectedRows.length === 1) {
        return <number> selectedRows[ 0 ];
      }
    }

    return -1;
  }

  public activateRow(row: number, scrollIntoView = true): void {
    if (this.listSpec.busListSpec.selection === 'disabled') {
      return; // safety
    }

    this.lmLoggerService.log([ this, this.instanceId, 'activateRow()' ]);

    if (this.sohoListView) {
      if (row === -1) {
        // need to send my own event, the soho grid does NOT fire
        // if the dataset is empty
        const listRowDeActivatedEvent: LMListRowActivatedEvent = {
          row: -1,
          item: null,
          fromDataView: this.fromDataView
        };
        this.lmListEventService.listRowDeactivatedEvent(listRowDeActivatedEvent);
      } else {
        this.sohoListView.activateItem(row);

        if (scrollIntoView) {
          // Focus on activated row
          const selectedElements = this.elementRef.nativeElement.getElementsByClassName('is-activated');
          if (this.sohoListView && selectedElements.length) {
            const selectedElement = selectedElements[0];
            this.lmCommonUtilService.scrollIntoView(selectedElement);
          }
        }
      }

      this.lmLoggerService.timeEnd('LMListView.end ' + this.instanceId);
    }
  }

  unSelectAllRows(): void {
    if (this.sohoListView) {
      this.sohoListView.clearAllSelected();
    }
  }

  activatedRow(): number {
    if (this.sohoListView) {
      const activatedItem = this.sohoListView.activatedItem();
      if (activatedItem && activatedItem.index !== undefined) {
        return activatedItem.index;
      }
    }
    return -1;
  }

  private handleInitialPageCancel() {
    this.reset();
    const message = '';
    const title = Soho.Locale.translate('NoDataAvailable');
    this.showEmptyMessage = true;
    this.handleError(message, title);
    this.changeDetectorRef.markForCheck();
  }

  private handleCancelableRequest(): void {
    if (this.implementsCancelablePaging && this.cancelPagingNotifier$) {
      this.cancelPagingNotifier$.next(true);
      this.cancelPagingNotifier$.complete();
      this.cancelPagingNotifier$ = null;
    }
  }

  private handleCancelableResponse(response: LMListPagingResponse): boolean {
    if (this.implementsCancelablePaging) {
      if (response.status === 'STARTED') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'started', cancelablePagingNotifier: response.cancelablePagingNotifier });
        this.cancelPagingNotifier$ = response.cancelablePagingNotifier;
        return true;
      } else if (response.status === 'WAITING') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'waiting' });
        return true;
      } else if (response.status === 'CANCELED') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'canceled' });
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        return true;
      } else {
        this.cancelPagingNotifier$ = null;
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'finished' });
        return false;
      }
    } else {
      return false;
    }
  }

  refresh(): Observable<boolean> {
    if (this.isBusyPaging()) {
      return of(true);
    }
    // console.log('listcard-refresh: ' + this.listSpec.busListSpec.name);
    this.listState.selectedRows = this.getSelectedRows();
    this.listState.activatedRow = this.activatedRow();
    return this.initialPageWait();
  }

  addDataView(dataView: LMDataView, index: number) {
    throw new Error('Method not implemented.');
  }

  removeDataView(index: number) {
    throw new Error('Method not implemented.');
  }

  public setDirtyIndicator(row: number, cell: number, showDirty: boolean) {
    throw new Error('Method not implemented.');
  }

  public getDirtyRows(): Array<LMDataView> {
    return [];
  }

  public isModified(): boolean {
    return false;
  }

  public onContextMenuItemSelected(actionReference: LMBusActionReference, selectedDataView?: LMDataView): void {
    // TODO
  }

  private initialPageWait(rebuildInitialPageUrl = false): Observable<boolean> {
    return this._initialPage(rebuildInitialPageUrl);
  }

  private initialPage(rebuildInitialPageUrl = false) {
    this._initialPage(rebuildInitialPageUrl).subscribe();
  }

  private _initialPage(rebuildInitialPageUrl = false): Observable<boolean> {
    return new Observable<boolean>(observer => {
      // console.log('listcard-initialPage: ' + this.listSpec.busListSpec.name);
      this.showEmptyMessage = false;
      this.lmLoggerService.log([ this, this.instanceId, 'initialPage()' ]);

      if (this.listSpec.dependentList) {
        if (this.fromDataView === null) {
          // disabled flag should be set at this point! That makes disabling
          // the component here seem like we are doing disabled checking in 2 spots.
          // todo: ppatton Look into more consistent (and single) way of disabling list-grid, list-view, etc...
          // this.disableComponent();

          /**
           * emitting the dataLoaded event with a null so the lm-list object
           * can responsd appropriately.
           * todo: ppatton again, why do this here?! shouldn't the lm-list already now it's been disabled?!
           */
          setTimeout(() => this.lmListEventService.dataLoadedEvent(null));
          observer.next(true);
          observer.complete();
          return;
        }
        // ------------------------------------------------------------------
        // if this is a dependentList then make sure all the dependencies
        // are available before loading the list.
        // ------------------------------------------------------------------
        if (!this.fromDataView || (this.hasFilterList && !this.filterListFilterCriteria)) {
          if (this.initialBuildComplete) {
            this.reset(); // don't reset if it hasn't even been built.
          }
          /**
           * emitting the dataLoaded event with a undefined dataView should
           * cause the lm-list to fully disable
           */
          setTimeout(() => {
            this.lmLoggerService.log([ this, this.instanceId, 'initialPage() > setTimeout > dataLoaded.emit(null)' ]);
            this.lmListEventService.dataLoadedEvent(null);
          });
          this.lmLoggerService.log([ this, this.instanceId, 'initialPage()', 'return' ]);
          observer.next(true);
          observer.complete();
          return;
        }
      }

      this.handleCancelableRequest();
      this.cancelOutstandingPagingRequest();
      this.showBusyIndicator();

      const url = this.buildInitialPageUrl(rebuildInitialPageUrl);
      let initialNbrRecs = this.lmListUtilService.isUseAsSearchTargetList(this.listSpec) ? 0 : this.pageSize;
      if (this.filterCriteria) {
        initialNbrRecs = this.pageSize;
      }
      const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

      const isManualLoad = this.isManualLoading();
      // console.log('list-card._initialPage: '+ this.listSpec.busListSpec.name);
      this.lmLoggerService.time({ id: 'LMListView.initialPage() ' + this.instanceId });
      this.pagingSubscription = this.lmListGridPagingService.initialPageFiltered(url, this.filterCriteria, initialNbrRecs, postContent, isManualLoad).subscribe(
        (listPagingResponse: LMListPagingResponse) => {
          this.hideBusyIndicator();

          if (this.handleCancelableResponse(listPagingResponse)) {
            if (listPagingResponse.status === 'CANCELED') {
              this.handleInitialPageCancel();
            }
            observer.next(true);
            observer.complete();
            return;
          }

          if (listPagingResponse.serverLog) {
            this.lmLoggerService.serverLog(listPagingResponse.serverLog);
          }

          this.lmLoggerService.timeEnd('LMListView.initialPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);


          if (listPagingResponse.status === 'COMPLETED') {
            this.postInitialLoad(listPagingResponse, false);
          } else {
            this.handleError(listPagingResponse.details, listPagingResponse.statusText);
          }
          observer.next(listPagingResponse.status === 'COMPLETED');
          observer.complete();
        },
        error => {
          observer.next(false);
          observer.complete();
          this.lmLoggerService.timeEnd('LMListView.initialPage() ' + this.instanceId, [ this ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

          this.handleError(error.stack, error.message);
        });
    });
  }

  public onFirstPage(event: any) {
    if (this.hasFirstPage) {
      this.handleCancelableRequest();
      this.cancelOutstandingPagingRequest();
      this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

      this.listState.selectedRows = this.getSelectedRows();
      this.listState.activatedRow = this.activatedRow();
      const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);


      this.lmLoggerService.time({ id: 'LMListView.firstPage() ' + this.instanceId });
      this.pagingSubscription = this.lmListGridPagingService.firstPage(this.dataViewSet, this.pageSize, postContent, null, this.selectRequestData).subscribe(
        (listPagingResponse: LMListPagingResponse) => {

          if (this.handleCancelableResponse(listPagingResponse)) {
            return;
          }

          if (listPagingResponse.serverLog) {
            this.lmLoggerService.serverLog(listPagingResponse.serverLog);
          }

          this.lmLoggerService.timeEnd('LMListView.firstPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

          if (listPagingResponse.status === 'COMPLETED') {
            this.postLoad(listPagingResponse, true);
          } else {
            this.handleError(listPagingResponse.details, listPagingResponse.statusText);
          }
        },
        (error: any) => {
          this.lmLoggerService.timeEnd('LMListView.firstPage() ' + this.instanceId, [ this ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
          this.handleError(error.stack, error.message);
        });
    }
  }

  public onLastPage() {
    if (this.hasLastPage) {
      this.handleCancelableRequest();
      this.cancelOutstandingPagingRequest();
      this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

      this.listState.selectedRows = this.getSelectedRows();
      this.listState.activatedRow = this.activatedRow();
      const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);


      this.lmLoggerService.time({ id: 'LMListView.lastPage() ' + this.instanceId });
      this.pagingSubscription = this.lmListGridPagingService.lastPage(this.dataViewSet, postContent, null, this.selectRequestData).subscribe(
        (listPagingResponse: LMListPagingResponse) => {

          if (this.handleCancelableResponse(listPagingResponse)) {
            return;
          }

          if (listPagingResponse.serverLog) {
            this.lmLoggerService.serverLog(listPagingResponse.serverLog);
          }

          this.lmLoggerService.timeEnd('LMListView.lastPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

          if (listPagingResponse.status === 'COMPLETED') {
            this.postLoad(listPagingResponse, true);
          } else {
            this.handleError(listPagingResponse.details, listPagingResponse.statusText);
          }
        },
        (error: any) => {
          this.lmLoggerService.timeEnd('LMListView.lastPage() ' + this.instanceId, [ this ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
          this.handleError(error.stack, error.message);
        });
    }
  }

  public onNextPage() {
    if (this.hasNextPage) {
      this.handleCancelableRequest();
      this.cancelOutstandingPagingRequest();
      this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

      this.listState.selectedRows = this.getSelectedRows();
      this.listState.activatedRow = this.activatedRow();
      const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);


      this.lmLoggerService.time({ id: 'LMListView.nextPage() ' + this.instanceId });
      this.pagingSubscription = this.lmListGridPagingService.nextPage(this.dataViewSet, postContent, null, this.selectRequestData).subscribe(
        (listPagingResponse: LMListPagingResponse) => {

          if (this.handleCancelableResponse(listPagingResponse)) {
            return;
          }

          if (listPagingResponse.serverLog) {
            this.lmLoggerService.serverLog(listPagingResponse.serverLog);
          }

          this.lmLoggerService.timeEnd('LMListView.nextPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

          if (listPagingResponse.status === 'COMPLETED') {
            this.postLoad(listPagingResponse, true);
          } else {
            this.handleError(listPagingResponse.details, listPagingResponse.statusText);
          }
        },
        error => {
          this.lmLoggerService.timeEnd('LMListView.nextPage() ' + this.instanceId, [ this ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
          this.handleError(error.stack, error.message);
        });
    }
  }

  onPreviousPage() {
    if (this.hasPreviousPage) {
      this.handleCancelableRequest();
      this.cancelOutstandingPagingRequest();
      this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

      this.listState.selectedRows = this.getSelectedRows();
      this.listState.activatedRow = this.activatedRow();
      const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);


      this.lmLoggerService.time({ id: 'LMListView.previousPage() ' + this.instanceId });
      this.pagingSubscription = this.lmListGridPagingService.previousPage(this.dataViewSet, postContent, null, this.selectRequestData).subscribe(
        (listPagingResponse: LMListPagingResponse) => {

          if (this.handleCancelableResponse(listPagingResponse)) {
            return;
          }

          if (listPagingResponse.serverLog) {
            this.lmLoggerService.serverLog(listPagingResponse.serverLog);
          }

          this.lmLoggerService.timeEnd('LMListView.previousPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

          if (listPagingResponse.status === 'COMPLETED') {
            this.postLoad(listPagingResponse, true);
          } else {
            this.handleError(listPagingResponse.details, listPagingResponse.statusText);
          }
        },
        error => {
          this.lmLoggerService.timeEnd('LMListView.previousPage() ' + this.instanceId, [ this ]);
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
          this.handleError(error.stack, error.message);
        });

    }
  }

  onPageSizeChange(event: any) {
    const args: any[] = event as any[];
    if (!this.showPageSizeSelector) {
      return; // safety
    }
    this.pageSize = args[1].pagesize;
    this.listPersonalization.pageSize = args[1].pagesize;
    this.refresh().subscribe();
  }

  public sortPage(sortOrder: LMListSortOrder): void {
    if (!sortOrder) {
      return;
    }
    this.handleCancelableRequest();
    this.cancelOutstandingPagingRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

    // -------------------------------------------------------------
    // Get the sort url
    // -------------------------------------------------------------
    let cardViewSortOrders: Array<LMCardSortOrder> = this.listSpec.busListSpec.displayFields[ 0 ].cardViewSortOrders;

    if (this.listSpec.busListSpec.responsiveCardView && this.listSpec.busListSpec.responsiveCardView.cardViewSortOrders) {
      cardViewSortOrders = this.listSpec.busListSpec.responsiveCardView.cardViewSortOrders;
    }

    const cardViewSortOrder: LMCardSortOrder = cardViewSortOrders.find(sort => sort.sortOrderName === sortOrder.sortOrderName);

    if (!cardViewSortOrder) {
      throw 'cannot find card view sort order info for ' + sortOrder.sortOrderName;
    }

    // NOTE: LMListGrid pagingRequest.sortAsc reflects the current sort not the requested sort.
    // LMListView does the opposite. This should be changed so they are consistent

    const url = this.buildInitialPageUrl(true);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    this.listState.sortOrderCriteria = sortOrder;

    // request the sorted page of records and log how long it took
    this.lmLoggerService.time({ id: 'LMListView.sortPage() ' + this.instanceId });
    this.pagingSubscription = this.lmListGridPagingService.sortPage(url, this.filterCriteria, sortOrder, this.pageSize, postContent).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListView.sortPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);

        if (listPagingResponse.status === 'COMPLETED') {
          this.postInitialLoad(listPagingResponse, true);
        }

        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'SYSTEM_EXCEPTION') {
          this.handleError(listPagingResponse.details, listPagingResponse.statusText);
          return;
        }
      },
      error => {
        this.lmLoggerService.timeEnd('LMListView.sortPage() ' + this.instanceId, [ this ]);
        this.handleError(error.stack, error.message);
        return;
      });
  }

  public filterPage(): void {
    // Return if no filterCriteria is set then return
    if (!this.filterCriteria) {
      return;
    }

    if (this.listSpec.dependentList && !this._fromDataView) {
      this.reset();
      return;
    }

    this.handleCancelableRequest();
    this.cancelOutstandingPagingRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

    const url = this.buildInitialPageUrl(true);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);


    this.lmLoggerService.time({ id: 'LMListView.filterPage() ' + this.instanceId });
    this.pagingSubscription = this.lmListGridPagingService.filterPage(url, this.filterCriteria, this.pageSize, postContent).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListView.filterPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        this.setEmptyMessage();

        if (listPagingResponse.status === 'COMPLETED') {
          this.postInitialLoad(listPagingResponse, true);
          this.listState.filterCriteria = this.filterCriteria;

        } else {
          this.handleError(listPagingResponse.details, listPagingResponse.statusText);
        }
      },
      error => {
        this.lmLoggerService.timeEnd('LMListView.filterPage() ' + this.instanceId, [ this ]);
        this.handleError(error.stack, error.message);
        return;
      });
  }

  private fireListRowSelectedEvent(event: any) {
    let rows: LMListRowData[] = event[1].selectedItems.map(elem => {
      const idx = elem.index();
      const data = this.dataViewSet.data[idx];
      return <LMListRowData>{ idx, data, elem };
    });

    // ------------------------------------------------------------------
    // Fire a selected event (with -1 index) to notify lm-list.component
    // ONLY when there are no other selected rows.
    // ------------------------------------------------------------------
    if (!rows.length) {
      rows = [ { idx: -1, data: null, elem: null } ];
    }

    this.lmListEventService.listRowSelectedEvent({ event, rows });
  }

  onKeyDown(event: LMListKeyDownEvent) {
    if (this.listSpec.listType === 'select' || this.listSpec.listType === 'helper') {
      return;
    }
    this.lmListEventService.listKeyDownEvent(event);
  }

  onItemsSelected(event: any) {
    this.fireListRowSelectedEvent(event);
  }

  onItemUnselected(event: any) {
    if (this.listSpec.dependentList && this.fromDataView === null) {
      // do not fire a unselected event when dependent list and fromDataView
      // is null. List will attempt to reselect the same row again when the
      // list is single select. This will cause a js error because when
      // fromDataView is null there is no data in the list to select.
      return;
    }
    this.fireListRowSelectedEvent(event);
  }

  onItemActivated(event: any) {
    const listRowActivatedEvent: LMListRowActivatedEvent = {
      row: event[ 1 ].index,
      item: event[ 1 ].elem,
      fromDataView: this.fromDataView,
      sourceIsPagingEvent: this.selectionInProgress
    };
    this.lmListEventService.listRowActivatedEvent(listRowActivatedEvent);
  }

  onItemDeactivated(event: any) {
    const listRowDeActivatedEvent: LMListRowActivatedEvent = {
      row: -1,
      item: event[ 1 ].elem,
      fromDataView: this.fromDataView
    };
    this.lmListEventService.listRowDeactivatedEvent(listRowDeActivatedEvent);
  }

  public onItemClicked(events: [JQuery.Event, any]) {
    if (!events || !events[1]) {
      return;
    }

    const event = events[1];
    const jqueryEvent = event.originalEvent;
    const mouseEvent = jqueryEvent.originalEvent as MouseEvent;

    const isCheckBox = mouseEvent.composedPath().some(pathElement =>
      (pathElement instanceof Element) &&
      (pathElement as Element).classList.contains('listview-selection-checkbox'));

    const isHyperlink = mouseEvent.composedPath().some(pathElement =>
      (pathElement instanceof Element) &&
      (pathElement as Element).classList.contains('hyperlink'));

    const isButton = mouseEvent.composedPath().some(pathElement =>
      (pathElement instanceof Element) &&
      (pathElement as Element).nodeName === 'BUTTON');

    const isClickableTag = mouseEvent.composedPath().some(pathElement =>
      (pathElement instanceof Element) &&
      (pathElement as Element).classList.contains('tag') &&
      (pathElement as Element).classList.contains('is-clickable'));

    if (isButton || isHyperlink || isCheckBox || isClickableTag) {
      return;
    }

    if (this.listSpec.busListSpec.selection === 'multiple') {
      /**
       * Fix for issue LMCLIENT-29260.
       *
       * BACKGROUND: We are using the activatedRow event to also select that activated row. But we don't auto select
       * the first row anymore on initial load. A multiselect list will now default so having a zeroth activated row but no row
       * will be selected.
       *
       * ISSUE: since first row is activated (and not selected) by default a new activated event will not be fired
       * if the user clicks on the activated row. There for no selection will take place.
       *
       * WORKAROUND: Manage the click event ourselves and decide if the setRowSelection should be called.
       */
      if (this.activatedRow() === event.index && this.getSelectedRows().length === 0) {
        this.setSelectedRows([ event.index ]);
      }
    }

    const item = (this.listSpec.listType === 'select' && this.lmContextService.useSingleSelectList() && !this.inSelectListEditMode)
      ? this.getDataView(event.index) : event.elem;

    this.lmListEventService.listRowClickedEvent({
      originalEvent: event.originalEvent,
      item,
      row: event.index,
      cell: -1
    } as LMListRowClickedEvent);
  }

  onItemDoubleClicked(event: any) {
    const target = event ? event[1] : null;
    if (target) {
      const listRowClickedEvent: LMListRowClickedEvent = {
        originalEvent: event,
        item: target.elem,
        row: target.index,
        cell: -1
      };
      this.lmListEventService.listRowDoubleClickedEvent(listRowClickedEvent);
    }
  }

  onDragged(event: DragEvent, data: LMDataView) {
    const draggedRow: number = data.id - 1;
    // event.preventDefault();
    // -------------------------------------------------------------
    // unselect any other selected rows, select the row being dragged
    // -------------------------------------------------------------
    const selectionRows: Array<number> = this.getSelectedRows();

    if (!selectionRows.includes(draggedRow)) {
      // then select the right clicked row - the right click menu is based on the selected rows
      this.unSelectAllRows();
      this.setSelectedRows([ draggedRow ], true);
    }

    const target = event.currentTarget as HTMLElement;

    target.style.borderWidth = '2px';
    target.style.borderStyle = 'dashed';
    target.style.borderColor = '#000';
    target.style.opacity = '0.4';

    if (typeof event.dataTransfer.setDragImage === 'function') {
      const dragIcon = document.createElement('img');
      dragIcon.src = '../lib/landmark/images/defaultPage.png';
      dragIcon.width = 100;
      event.dataTransfer.setDragImage(dragIcon, -10, -10);

      event.dataTransfer.dropEffect = 'move';
    }
    event.dataTransfer.setData('text', draggedRow.toString());
  }

  onDragEnd(event: DragEvent, data: LMDataView) {
    const target = event.currentTarget as HTMLElement;

    target.style.border = 'none';
    target.style.opacity = '1';

    return false;
  }

  public onContextMenu(event: any): void {
    const target = event ? event[1] : null;

    const elem = target.elem;
    const rect = elem[0].getBoundingClientRect();

    // Manually set context menu position if undefined
    target.originalEvent.pageX = target.originalEvent.clientX ? target.originalEvent.clientX : rect.x + 100;
    target.originalEvent.pageY = target.originalEvent.clientY ? target.originalEvent.clientY : rect.y + 30;
    target.originalEvent.pageX = target.originalEvent.pageX ? target.originalEvent.pageX : rect.x + 100;
    target.originalEvent.pageY = target.originalEvent.pageY ? target.originalEvent.pageY : rect.y + 30;

    if (target) {
      const selectedListRow: LMContextMenuEvent = {
        row: target.index,
        item: target.elem,
        originalEvent: target.originalEvent,
        cell: -1,
        type: 'list'
      };
      this.lmListEventService.contextMenuEvent(selectedListRow);
    }
  }

  /**
   * Collapse this list-view
   */
  public collapseList() {
    this.lmListEventService.collapseDrawerSide();
  }

  private reset(): void {
    // set dataViewSet
    this.dataViewSet = undefined;
    this.recordCount = 0;

    // set pager button state
    this.hasNextPage = false;
    this.hasPreviousPage = false;
    this.hasFirstPage = false;
    this.hasLastPage = false;
    this.showPageSizeSelector = false;

    // todo need to remove any selection and any data currently in the list-view
    if (this.sohoListView) {
      this.sohoListView.clearAllSelected();
      this.sohoListView.dataset = [];
    }
  }

  private postInitialLoad(listPagingResponse: LMListPagingResponse, resetSelection: boolean) {
    this.lmLoggerService.time({ id: 'LMListView.postInitialLoad() ' + this.instanceId });

    listPagingResponse.resetSelection = resetSelection;
    this.postLoad(listPagingResponse);
    this.setEmptyMessage();

    this.firstPageButtonTooltip = this.dataViewSet.pagingInfo.firstDisabledReason ?
      this.dataViewSet.pagingInfo.firstDisabledReason : Soho.Locale.translate('FirstPage');

    this.previousPageButtonTooltip = this.dataViewSet.pagingInfo.previousDisabled ?
      this.dataViewSet.pagingInfo.previousDisabledReason : Soho.Locale.translate('PreviousPage');

    this.nextPageButtonTooltip = this.dataViewSet.pagingInfo.nextDisabledReason ?
      this.dataViewSet.pagingInfo.nextDisabledReason : Soho.Locale.translate('NextPage');

    this.lastPageButtonTooltip = this.dataViewSet.pagingInfo.lastDisabledReason ?
      this.dataViewSet.pagingInfo.lastDisabledReason : Soho.Locale.translate('LastPage');

    /**
     * fire dataloaded event once listview has been initially loaded with data.
     * Do not fire for any other paging requests other than 'initialPage' load.
     */
    setTimeout(() => {
      this.lmLoggerService.log([ this, this.instanceId, 'postInitialLoad() > setTimeout > dataLoadedEvent' ]);
      this.lmListEventService.dataLoadedEvent(listPagingResponse);
    }, 1);

    this.showEmptyMessage = this.recordCount === 0;

    this.lmLoggerService.timeEnd('LMListView.postInitialLoad() ' + this.instanceId, [ this ]);
    this.lmLoggerService.timeEnd('>> Total ListView ' + this.instanceId, [ this ]);
    this.lmLoggerService.time({ id: 'LMListView.end ' + this.instanceId });
  }

  private postLoad(listPagingResponse: LMListPagingResponse, resetSelection = false) {
    this.lmLoggerService.time({ id: 'LMListView.postLoad() ' + this.instanceId });

    this.resetSelectionFlag = resetSelection;
    this.selectionInProgress = resetSelection;

    // Create specFields for message rules
    this.lmListUtilService.setSpecFields(listPagingResponse.dataViewSet);

    // set dataViewSet
    this.dataViewSet = listPagingResponse.dataViewSet;
    this.savedSearches = listPagingResponse.savedSearchDataViewSet;
    this.recordCount = listPagingResponse.dataViewSet.data.length;

    // set pager button state
    this.hasNextPage = this.dataViewSet.pagingInfo.hasNext && !this.dataViewSet.pagingInfo.nextDisabled && this.dataViewSet.data.length > 0;
    this.hasPreviousPage = this.dataViewSet.pagingInfo.hasPrevious && !this.dataViewSet.pagingInfo.previousDisabled && this.dataViewSet.data.length > 0;
    this.hasFirstPage = this.dataViewSet.pagingInfo.hasPrevious && !this.dataViewSet.pagingInfo.firstDisabled && this.dataViewSet.data.length > 0;
    this.hasLastPage = this.dataViewSet.pagingInfo.hasNext && !this.dataViewSet.pagingInfo.lastDisabled && this.dataViewSet.data.length > 0;
    this.showPageSizeSelector = this.lmListUtilService.showPageSizeChooser(this.listSpec);

    this.hidePagerBar = this._hidePagerBar();

    this.listState.currentPageUrl = this.dataViewSet.pagingUrls.reloadPageUrl;
    if (this.hasFilterList) {
      this.listState.filterListFilterCriteria = this.filterListFilterCriteria;
    }

    if (this.sohoListView) {
      this.sohoListView.updateRequired = true;

      // Calling change detection here so that lists that are in dialogs
      // will display the paging records. See LMCLIENT-31560.
      if (this.listSpec.listType === 'select'
        || this.listSpec.listType === 'helper') {
        // CHANGE DETECTION
        this.changeDetectorRef.markForCheck();
      }
    }
  }

  private resetSelection(selectRow: number, activatedRow: number) {
    if (selectRow !== -1) {
      if (selectRow >= this.dataViewSet.data.length) {
        selectRow = this.dataViewSet.data.length - 1;
      }
      this.setSelectedRows([ selectRow ], false);
    }

    if (this.selectionMode === 'mixed') {
      if (activatedRow !== -1) {
        if (activatedRow >= this.dataViewSet.data.length) {
          activatedRow = this.dataViewSet.data.length - 1;
        }

        // ----------------------------------------------------------------------------
        // if activeRow is -1 at this point then the last record must have been
        // deleted. activateRow will handle the -1 by deactivating the row and
        // will fire and event up so a list can clear any related data associated
        // with the recently deleted record.
        // ----------------------------------------------------------------------------

      } else if (this.dataViewSet && this.dataViewSet.data.length > 0) {
        // ----------------------------------------------------------------------------
        // if list was empty and a new records was created then activate the first row
        // ----------------------------------------------------------------------------
        activatedRow = 0;
      }

      this.activateRow(activatedRow);
      this.selectionInProgress = false;
    }

    if (this.lmContextService.useSingleSelectList()) {
      if (this.selectionMode === 'mixed' && activatedRow >= 0) {
        this.elementRef.nativeElement.getElementsByClassName('is-activated')[0]?.focus();
      } else if (this.selectionMode === 'single' && selectRow >= 0) {
        this.elementRef.nativeElement.getElementsByClassName('is-selected')[0]?.focus();
      }
    }

    this.lmLoggerService.timeEnd('LMListView.postLoad() ' + this.instanceId, [ this, this.dataViewSet ]);
  }

  public updateDataViewTransaction(key: number, status: string, message: string): void {
    // TODO implement me.
  }

  private buildInitialPageUrl(forceUrlRebuild = false): string {

    if (this.listSpec.dependentList) {
      if (this.listState
        && this.listState.currentPageUrl
        && !forceUrlRebuild
        && !this.dependencyChanged()
        && this.lmUrlUtilService.allCsksMatchContext(this.listState.currentPageUrl)
      ) {
        // ------------------------------------------------------------------
        // if the fromDataView hasn't changed and there is a currentPageUrl
        // then load that to keep our position in the dependent list.
        // ------------------------------------------------------------------
        return this.listState.currentPageUrl;
      }

      // ------------------------------------------------------------------
      // else resolve template against the fromDataView's resourceId and
      // it's filterListFilterCriteria if this list has a FilterList
      // dependency
      // ------------------------------------------------------------------
      const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.initialDataUrl);
      let compiledUrl = compiledUrlTemplate.expand({ resourceId: this.fromDataView.resourceId });
      const delimiter: string = compiledUrl.indexOf('?') === -1 ? '?' : '&';

      if (this.hasFilterList && this.filterListFilterCriteria && this.filterListFilterCriteria) {
        // ------------------------------------------------------------------
        // apply any filterListFilterCriteria to the initial load.
        // ------------------------------------------------------------------    // set filter criteria on the url params
        const filterParamString = this.lmUrlUtilService.filterFieldCriteriaToUrlParams(this.filterListFilterCriteria, 'flc');
        if (filterParamString) {
          compiledUrl += delimiter + filterParamString;
        }
      }

      return compiledUrl;
    }

    if (this.listState
      && this.listState.currentPageUrl
      && !forceUrlRebuild
      && this.lmUrlUtilService.allCsksMatchContext(this.listState.currentPageUrl)
      && this.lmUrlUtilService.hasSameParamValue(this.listState.currentPageUrl, this.listUrlInfo.initialDataUrl, 'filter')
    ) {
      let currentUrl = this.listState.currentPageUrl;
      if (this.selectRequestData?.onSearchForm) {
        currentUrl = this.lmUrlUtilService.addParamToUrl(currentUrl, 'searchform', 'true');
      }
      return currentUrl;
    }

    let url = this.listUrlInfo.initialDataUrl;
    if (this.selectRequestData?.onSearchForm) {
      url = this.lmUrlUtilService.addParamToUrl(url, 'searchform', 'true');
    }

    return url;
  }

  private dependencyChanged() {
    if (!this.listSpec.dependentList || !this.listState) {
      // --------------------------------------------------------------
      // Must be a dependent list and have listState to check against
      // for a dependency to have changed. If not return false.
      // --------------------------------------------------------------
      return false;
    }

    // --------------------------------------------------------------
    // If the from dataView resourceId change then the dependency
    // has changed. return true.
    // --------------------------------------------------------------
    if (this.fromDataView.resourceId !== this.listState.fromResourceId) {
      return true;
    }

    if (this.hasFilterList) {
      if (!this.listState.filterListFilterCriteria || this.listState.filterListFilterCriteria.length === 0) {
        // filter list criteria was empty, now it's been set.
        return (this.filterListFilterCriteria && this.filterListFilterCriteria.length >= 1);
      }

      // --------------------------------------------------------------
      // If this list has a filterList then check to see if the
      // filterListFilterCriteria has changed. If so then return true.
      // --------------------------------------------------------------
      // todo ppatton - this is NOT robust AT ALL. Need to handle checking multiple filterListCriteria elements.
      return this.filterListFilterCriteria[ 0 ].value !== this.listState.filterListFilterCriteria[ 0 ].value;
    }

    return false;
  }

  updateDataView(key: number, dataView: LMDataView): void {
  }

  trackByResourceId(index: number, dataView: LMDataView): string {
    return dataView.resourceId;
  }

  protected _hidePagerBar(): boolean {
    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)) {
      return true;
    }

    if (this.isFilterList) {
      return true;
    }

    return super._hidePagerBar();
  }

  private showBusyIndicator() {
    if (!this.hasFilterList && !this.isFilterList) {
      this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    } else {
      // console.log('busyIndicatorDisplayedEvent - List View')
      this.lmListEventService.busyIndicatorDisplayedEvent({ show: true });
    }
  }

  private hideBusyIndicator() {
    if (!this.hasFilterList && !this.isFilterList) {
      this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
    } else {
      this.lmListEventService.busyIndicatorDisplayedEvent({ show: false });
    }
  }
}
